import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function LmsButton({ className, style, children, moodleRedirect }) {
  const navigate = useNavigate();
  const { user, authHeaders } = useAuth();
  const [loading, setLoading] = useState(false);
  const [erreur,  setErreur]  = useState('');

  const handleClick = async () => {
    setErreur('');

    if (!user) {
      navigate('/inscription');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/moodle/sso`, {
        headers: authHeaders(),
      });

      const data = await res.json();

      if (!res.ok) {
        setErreur(data.error || 'Erreur SSO — réessayez ou contactez l\'administrateur.');
        return;
      }

      if (data.url) {
        let url = data.url;
        if (moodleRedirect) {
          url += (url.includes('?') ? '&' : '?') + `redirect=${encodeURIComponent(moodleRedirect)}`;
        }
        window.open(url, '_blank');
      } else {
        setErreur('URL Moodle introuvable dans la réponse.');
      }
    } catch {
      setErreur('Impossible de contacter le serveur. Vérifiez que le backend est démarré.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'inline-block' }}>
      <button
        onClick={handleClick}
        disabled={loading}
        className={className}
        style={style}
      >
        {loading ? '⏳ Connexion en cours...' : children}
      </button>
      {erreur && (
        <div
          className="mt-2 px-3 py-2 rounded-lg text-xs font-semibold text-red-700"
          style={{ background: '#fef2f2', border: '1px solid #fecaca', maxWidth: '280px' }}
        >
          ⚠️ {erreur}
        </div>
      )}
    </div>
  );
}

export default LmsButton;
